/**
 * Capira Footer — assets/capira-footer.js
 * Scroll-triggered reveals, staggered nav columns.
 */
(function () {
  'use strict';

  const pref   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const footer = document.getElementById('capira-footer');
  if (!footer) return;

  function observe(target, cb, threshold) {
    if (pref) { cb(); return; }
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) { cb(); io.disconnect(); }
    }, { threshold: threshold || 0.06 });
    io.observe(target);
  }

  /* ── 1. Statement + top-right ───────────────── */
  const revealEls = footer.querySelectorAll('[data-foot-reveal]');
  observe(footer.querySelector('.capira-foot__top') || footer, () => {
    revealEls.forEach(el => {
      const d = parseInt(el.dataset.footDelay || '0', 10);
      setTimeout(() => el.classList.add('is-visible'), pref ? 0 : d);
    });
  }, 0.04);

  /* ── 2. Rules ─────────────────────────────── */
  footer.querySelectorAll('[data-foot-rule]').forEach((el, i) => {
    observe(el, () => {
      setTimeout(() => el.classList.add('is-visible'), pref ? 0 : i * 80);
    }, 0.01);
  });

  /* ── 3. Shopify design mode ───────────────────── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      if (!e.target.contains(footer)) return;
      revealEls.forEach(el => el.classList.add('is-visible'));
      footer.querySelectorAll('[data-foot-rule]').forEach(el => el.classList.add('is-visible'));
    });
  }

})();
